import UUID from "@/utils/uuid";
import { getStorage, setStorage } from "@/utils/storage";
import router from "@/router-v2";
import { fleetLogout } from "@/api/user";
import store from '@/store'
import { systemInfo } from "@/shared-services";
// beforeEach
if (systemInfo.isCommand) {
  router.beforeEach((to, from, next) => {
    if (systemInfo.isCommand && getStorage()) {
      // 登录用户设置 loginTimestamp 和 tp_protal_uuid
      let logoutTimestamp = getStorage("logoutTimestamp") / 1;
      let loginTimestamp = getStorage("loginTimestamp") / 1;
      let uuid = getStorage("tp_protal_uuid");
      let parms = {
        startTime: loginTimestamp,
        endTime: logoutTimestamp,
        uuid: uuid,
      };
      if (
        uuid &&
        loginTimestamp &&
        logoutTimestamp &&
        !sessionStorage.getItem("timestampFlag")
      ) {
        fleetLogout(parms);
      }
      if (!sessionStorage.getItem("timestampFlag")) {
        let loginTimestamp = new Date().getTime();
        setStorage(loginTimestamp, "loginTimestamp");
      }
      if (!getStorage("tp_protal_uuid")) {
        setStorage(UUID.uuid(16, 32), "tp_protal_uuid");
      }
      if (!sessionStorage.getItem("timestampFlag")) {
        sessionStorage.setItem("timestampFlag", true);
      }
      if(from.path.includes('/login')) {
        let timer = setInterval(function () {
            // 判断文档和所有子资源(图片、音视频等)已完成加载
            if (document.readyState === 'complete') {
                //执行方法
                setTimeout(() => {
                  const authInfo = getStorage("IMAuth");
                  if (authInfo) store.dispatch("im/initIMToken", authInfo);
                  window.clearInterval(timer)
                });
            }
        }, 500)
      }
    }
    next();
  });
}
window.onbeforeunload = function () {
  if (getStorage()) {
    // 登录用户设置 退出记录logoutTimestamp
    let logoutTimestamp = new Date().getTime();
    setStorage(logoutTimestamp, "logoutTimestamp");
  }
};
